<template lang="pug">
  DataImportBase(
    :title="'藥物'"
    :uploadUrl="'/upload-medication-table/'"
    :downloadUrl="'/export-medication-table/'"
  )
</template>

<script>
import DataImportBase from './DataImportBase';

export default {
  name: 'DrugImport',
  components: {
    DataImportBase,
  },
};
</script>




// WEBPACK FOOTER //
// DrugImport.vue?44585949